<template>
  <div class="scrEnd">
    <p class="ln3">К сожалению компания отказала вам в выдаче займа, повторное обращение возможно через 1 месяц.</p>
  </div>
</template>

<script>
export default {
	name: "abtScrEndSorm",
	components: { },
}
</script>

<style scoped>
.scrEnd{text-align: center;padding: 15vw 0;background: white;}
.ln1{font-size: 7vw;font-weight: bold;padding-top: 8vw;}
.ln2{font-size: 5.6vw;padding: 2vw 0;}
.ln3{color:#869A95;font-size: 5vw}
@media screen and (min-width: 760px) {
	.scrEnd{padding: 8vw 0;}
	.ln1{font-size: 2vw;padding-top: 3vw;}
	.ln2{font-size: 1.6vw;padding: 1vw 0;}
	.ln3{font-size: 1.4vw;}
}
@media screen and (min-width: 1140px) {
	.scrEnd{padding: 40px 0;}
	.ln1{font-size: 22px;padding-top: 40px;}
	.ln2{font-size: 18px;padding: 15px 0;}
	.ln3{font-size: 16px;}
}
</style>
